<template>
  <div class="h-8 w-px bg-surface-200 dark:bg-surface-700" />
</template>
